// @flow
import React from "react";

type Props = {
  className?: string,
};

export const Calendar = ({ className }: Props) => (
  <svg
    clasname={className}
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="#353F52" fillRule="evenodd">
      <path
        d="M6,3 L26,3 C27.6568542,3 29,4.34314575 29,6 L29,26 C29,27.6568542 27.6568542,29 26,29 L6,29 C4.34314575,29 3,27.6568542 3,26 L3,6 C3,4.34314575 4.34314575,3 6,3 Z M6,5 C5.44771525,5 5,5.44771525 5,6 L5,26 C5,26.5522847 5.44771525,27 6,27 L26,27 C26.5522847,27 27,26.5522847 27,26 L27,6 C27,5.44771525 26.5522847,5 26,5 L6,5 Z"
        id="Rectangle"
      />
      <rect id="Rectangle" x="3" y="9" width="26" height="2" />
      <rect id="Rectangle" x="14" y="13" width="4" height="2" rx="1" />
      <rect id="Rectangle" x="21" y="13" width="4" height="2" rx="1" />
      <rect id="Rectangle" x="7" y="18" width="4" height="2" rx="1" />
      <rect id="Rectangle" x="14" y="18" width="4" height="2" rx="1" />
      <rect id="Rectangle" x="21" y="18" width="4" height="2" rx="1" />
      <rect id="Rectangle" x="7" y="23" width="4" height="2" rx="1" />
      <rect id="Rectangle" x="14" y="23" width="4" height="2" rx="1" />
    </g>
  </svg>
);
